const targetScrollElement = document.querySelector('#subscription-modal ');
var modalOpen = new Boolean();
var primaryQuantityInputs = document.querySelectorAll('#subscription-modal input.quantity__input.primary');
var formRadioButtons = document.querySelectorAll('#subscription-modal input[type=radio]');
var addonProductCards = document.querySelectorAll('#addon-swiper .addon-card div.add-addon');
var addonProductRemove = document.querySelectorAll('div[data-addon] div[data-remove]');

// Subscription Data
var subscriptionValues = {
  orderQuantity: 1,
  orderVariant: '',
  orderVariantPrice: 0,
  orderPrimaryLineTotal: 0,
  orderVariantTitle: '',
  orderFrequency: '',
  orderFrequencyUnit: 'Weeks',
  sellingPlan: '',
  sellingPlanName: '',
  orderAddons: {},      
};

// Init subscription object with default values
subscriptionValues.orderVariant = document.querySelector('div[data-subscription-step="1"] input:checked').value;
subscriptionValues.orderVariantTitle = document.querySelector('div[data-subscription-step="1"] input:checked').getAttribute('data-variant-title');
subscriptionValues.orderVariantPrice = document.querySelector('div[data-subscription-step="1"] input:checked').getAttribute('data-variant-price');
subscriptionValues.orderPrimaryLineTotal = subscriptionValues.orderVariantPrice * 1;
subscriptionValues.sellingPlan = document.querySelector('div[data-subscription-step="2"] input:checked').value;
subscriptionValues.sellingPlanName = document.querySelector('div[data-subscription-step="2"] input:checked + label p[data-selling-plan-name]').textContent

// Update default content
document.querySelector('div#subscription-modal span[data-subtotal]').innerHTML = '$' + subscriptionValues.orderVariantPrice;
document.querySelector('div#subscription-modal div[data-primary-line-total]').innerHTML = '$' + subscriptionValues.orderVariantPrice;
document.querySelector('p[data-sub-frequency]').innerHTML = subscriptionValues.sellingPlanName
document.querySelector('p[data-primary-variantTitle]').innerHTML = subscriptionValues.orderVariantTitle == "Default" ? "" : subscriptionValues.orderVariantTitle;    

// Currency Formatter
var currencyFormatter = new Intl.NumberFormat('en-NZ', {
  style: 'currency',
  currency: 'NZD',
  maximumFractionDigits: 2,  
});


// Subscription Reveal / Conceal
var subscriptionModalTimeline = gsap.timeline().reversed(true);

subscriptionModalTimeline.to('#subscription-mask', {
  opacity: 0.45,  
  duration: 0.3,
  pointerEvents: 'auto',
  ease: 'ease-in-out',
});

subscriptionModalTimeline.to('#subscription-modal', {
  translateX: '-100%',  
  duration: 0.3,
}, 0.0);

function toggleSubscriptionModal() {    
  if (modalOpen) {
    bodyScrollLock.disableBodyScroll(targetScrollElement);
  } else {
    bodyScrollLock.enableBodyScroll(targetScrollElement);
  }
  modalOpen = !modalOpen;
  subscriptionModalTimeline.reversed(!subscriptionModalTimeline.reversed());      
}


// Subscription Addon Swiper
const swiperSubscriptionModal = new Swiper('#addon-swiper', {
  slidesPerView: 2,
  direction: 'horizontal',    
  draggable: false,
  speed: 400,
  spaceBetween: 16,
  loop: false,  
});

function concealSubscribeStep(target) {  
  var concealSubscribeStepTimeline = gsap.timeline();  
  concealSubscribeStepTimeline.to(target, {
    opacity: 0,  
    duration: 0.2, 
    ease: 'ease-in-out',
  });  
  concealSubscribeStepTimeline.to(target, {
    display:'none',
    duration: 0.05,
  }, 0.2);
}

function revealSubscribeStep(target) {  
  var revealSubscribeStepTimeline = gsap.timeline();  
  revealSubscribeStepTimeline.to(target, {
    display:'block',
    duration: 0.05    
  });  
  revealSubscribeStepTimeline.to(target, {
    opacity: 1,  
    duration: 0.2, 
    ease: 'ease-in-out'
  }, 0.05);
}

// Navigate Subscription Modal
function navigateSubModal(direction) {  
    var currentStep = document.querySelector('#subscription-modal div[data-active="true"]'),
      currentStepNav = document.querySelector('#step-nav li[data-step-active="true"]'),
      prevBtn = document.querySelector('#subscription-modal button[data-prev]'),
      nextBtn = document.querySelector('#subscription-modal button[data-next]'),
      submitBtn = document.querySelector('#subscription-modal button[data-submit]');

    concealSubscribeStep(currentStep);

    currentStep.setAttribute('data-active', "false");  
    currentStepNav.setAttribute('data-step-active', "false");
    currentStepNav.classList.add('opacity-50');  
    
    if (direction == "next") {    
      var targetStep = currentStep.nextElementSibling;    
      var targetStepNav = currentStepNav.nextElementSibling;    
    } else {            
      var targetStep = currentStep.previousElementSibling;    
      var targetStepNav = currentStepNav.previousElementSibling;    
    }
  
    if (targetStep.getAttribute('data-subscription-step') != '1') {
      prevBtn.classList.remove('opacity-0', 'pointer-events-none');
    } else {
      prevBtn.classList.add('opacity-0', 'pointer-events-none');
    }
  
    if (targetStep.getAttribute('data-subscription-step') == '4') {
      submitBtn.classList.remove('hidden');
      nextBtn.classList.add('hidden');
    } else {
      submitBtn.classList.add('hidden');
      nextBtn.classList.remove('hidden');
    }
          
    setTimeout(() => {
      revealSubscribeStep(targetStep);
      targetStep.setAttribute("data-active", "true");
      targetStepNav.classList.remove('opacity-50');  
      targetStepNav.setAttribute('data-step-active', "true");
    }, 300);
    
  }

  

// Form Radio button change function
function subscriptionOptionSelect(radio) {  
  var targetValue = radio.name;  
  if (targetValue == 'orderVariant') {
    subscriptionValues.orderVariant = radio.value;
    subscriptionValues.orderVariantTitle = radio.getAttribute('data-variant-title');
    subscriptionValues.orderVariantPrice = Number(radio.getAttribute('data-variant-price'));
  }
  if (targetValue == 'orderFrequency') {
    subscriptionValues.sellingPlan = radio.value;
    subscriptionValues.sellingPlanName = radio.getAttribute('data-plan-name');
  } 

  // Calculate total cost
  subscriptionValues.orderPrimaryLineTotal = subscriptionValues.orderQuantity * subscriptionValues.orderVariantPrice;
  updateSubscriptionSummary();

}

formRadioButtons.forEach(radio => radio.addEventListener('change', () => subscriptionOptionSelect(radio)));



// Main item quantity change event
primaryQuantityInputs.forEach(primary => primary.addEventListener('change', () => {     
  subscriptionValues.orderQuantity = Number(primary.value);
  subscriptionValues.orderPrimaryLineTotal = subscriptionValues.orderQuantity * subscriptionValues.orderVariantPrice;          
  updateSubscriptionSummary();
}));  




// Addon Product Inclusion Toggle
function subscriptionAddToOrder(addon) {  

  //add to summary    
  addon.classList.add('selected');  
  var newItem = `<div data-addon="${addon.getAttribute('data-addon')}" ${addon.getAttribute('data-frequency') ? `data-frequency="${addon.getAttribute('data-frequency')}"` : ''} data-price="${addon.getAttribute('data-price')}" class="sub-addon trans-std w-full grid grid-cols-6 gap-gutter b-top py-4 text-sm">
                    <img class="col-span-1" src="${addon.getAttribute('data-image')}" alt="${addon.getAttribute('data-title')}" loading="lazy" />
                    <div class="col-span-2">
                    <p>${addon.getAttribute('data-title')}</p>
                    ${addon.getAttribute('data-variant-title') && addon.getAttribute('data-variant-title') !== 'Default Title' ? `<p class="mt-2" data-primary-varianttitle="">${addon.getAttribute('data-variant-title')}</p>` : ''}
                    ${addon.getAttribute('data-selling-plan-name') ? `<p class="mt-2" data-primary-variantfrequency="">${addon.getAttribute('data-selling-plan-name')}</p>` : ''}
                    </div>
                    <div class="col-span-2">
                    <quantity-input class="quantity">
                    <button class="quantity__button light no-js-hidden" name="minus" type="button">
                    <span class="visually-hidden">{{ 'products.product.quantity.decrease' | t: product: product.title | escape }}</span>
                    <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.0265625 2.544H4.97056V0.992H0.0265625V2.544Z" fill="black"/>
                        </svg>              
                    </button>
                    <input class="quantity__input addon"
                        type="number"
                        onchange="addonQuantityChange(this)"
                        data-id="${addon.getAttribute('data-addon')}"
                        name="quantity"
                        id="Quantity-${addon.getAttribute('data-addon')}"
                        min="1"
                        value="${addon.querySelector('.quantity__input').value}"
                    >
                    <button class="quantity__button light no-js-hidden" name="plus" type="button">
                    <span class="visually-hidden">{{ 'products.product.quantity.increase' | t: product: product.title | escape }}</span>
                    <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.66875 7.192H4.33275V4.744H6.73275V3.192H4.33275V0.728H2.66875V3.192H0.26875V4.744H2.66875V7.192Z" fill="black"/>
                        </svg>              
                    </button>
                </quantity-input> 
                <div data-remove onclick="addonRemove(this)" class="mt-2 cursor-pointer trans-std hover:underline">Remove</div>
                    </div>
                    <div class="col-span-1 text-right" data-summary-varLinePrice data-line-total="${Number(addon.getAttribute('data-price') * Number(addon.querySelector('.quantity__input').value)).toFixed(2)}">$${Number(addon.getAttribute('data-price') * addon.querySelector('.quantity__input').value).toFixed(2)}</div></div>`;
  document.querySelector(`#summary-products`).innerHTML += newItem;
  setTimeout(function() {addon.classList.remove('selected')}, 1500);
  updateSubscriptionSummary();

};

addonProductCards.forEach(addon => addon.addEventListener('click', () => {
  subscriptionAddToOrder(addon.closest('.addon-card'));
}));

// Addon Quantity Update & Sync
function addonQuantityChange(input) {
  var targetId = input.getAttribute('data-id');
  document.querySelector(`#addon-swiper .addon-card[data-addon="${targetId}"] input.quantity__input`).value = input.value;
  document.querySelector(`#summary-products .sub-addon[data-addon="${targetId}"] input.quantity__input`).value = input.value;
  // Update addon line total price
  var linePrice = input.closest('.sub-addon').getAttribute('data-price');
  var lineTotal = input.value * Number(linePrice);
  input.closest('.sub-addon').querySelector('div[data-line-total]').innerHTML = currencyFormatter.format(lineTotal);
  updateSubscriptionSummary();
}

// Addon Remove
function addonRemove(clicked) {
  var targetAddon = clicked.closest('div.sub-addon');
  var targetId = targetAddon.getAttribute('data-addon');
  document.querySelector(`#addon-swiper .addon-card[data-addon="${targetId}"]`).classList.remove('selected');
  targetAddon.classList.add('opacity-0', 'h-0');
  setTimeout(() => {
    targetAddon.remove();
    updateSubscriptionSummary();
  }, 300);      
}
 

  
  function updateSubscriptionSummary() {    

    // Sync all inputs    
    primaryQuantityInputs.forEach(input => input.value = subscriptionValues.orderQuantity);

    // Frequency
    document.querySelectorAll('p[data-sub-frequency]').forEach(label => label.innerHTML = subscriptionValues.sellingPlanName );

    // Primary Line Total
    var primaryLineTotal = currencyFormatter.format();
    document.querySelector('div[data-primary-product] div[data-primary-line-total]').innerHTML = currencyFormatter.format(subscriptionValues.orderPrimaryLineTotal);
    // Primary Variant Title
    document.querySelector('p[data-primary-variantTitle]').innerHTML = subscriptionValues.orderVariantTitle == "Default" ? "" : subscriptionValues.orderVariantTitle;    
    
    // Subtotal
    var addonsTotal = 0;
    Array.from(document.querySelectorAll('.sub-addon[data-addon]')).forEach(addon => {       
      addonsTotal = addonsTotal  + (Number(addon.getAttribute('data-price')) * Number(addon.querySelector('.quantity__input').value));
    });    
    var subtotal = subscriptionValues.orderPrimaryLineTotal + addonsTotal
    subtotal = currencyFormatter.format(subtotal);
    document.querySelector('span[data-subtotal]').innerHTML = subtotal;                            
  }

 

// Add single item to cart
function addItemToCart(id, quantity, frequency, frequencyUnit) {
  data = {
    "id": id,
    "quantity": quantity,
    "properties": {
      "shipping_interval_frequency": frequency,
      "shipping_interval_unit_type": frequencyUnit
    }
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  config.headers['Content-Type'] = 'application/json';  
  config.body = JSON.stringify(data);

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {        
        return;
      }
      
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {           
    });
}

// Add all items from summary to the cart
function addSubscriptionToCart() {   
  var cartItems = [];

  cartItems.push(
    { 
      id: subscriptionValues.orderVariant,
      quantity: subscriptionValues.orderQuantity,
      selling_plan: subscriptionValues.sellingPlan,

    }
  );

  Array.from(document.querySelectorAll('.sub-addon[data-addon]')).forEach(addon => {   
    const sellingPlan = addon.getAttribute('data-frequency');
    
    cartItems.push(
      { 
        id: addon.getAttribute('data-addon'),
        quantity: Number(addon.querySelector('.quantity__input').value),
        ...(sellingPlan ? { selling_plan: sellingPlan } : {})
      }
    );
  }); 

  

  const atcOptions = {
    firstComplete: ( requestState ) => {
      document.querySelector('#subscription-modal .atc').innerHTML = "Adding to cart";
    },
    lastComplete: ( requestState ) => {
      document.querySelector('#subscription-modal .atc').innerHTML = "Add to cart";
      toggleSubscriptionModal();        
        toggleCart();
    }
  }
  
  window.liquidAjaxCart.cartRequestAdd({ 
    items: cartItems
  }, atcOptions ) 

  

}

function updateAddonVariant(sel) {
  sel.closest('.addon-card').setAttribute('data-addon', sel.options[sel.selectedIndex].value)
  sel.closest('.addon-card').setAttribute('data-variant-title', sel.options[sel.selectedIndex].text)
  sel.closest('.addon-card').setAttribute('data-price', sel.options[sel.selectedIndex].getAttribute('data-price'));
  sel.closest('.addon-card').querySelector('div[data-variant-price]').innerHTML = "$" + sel.options[sel.selectedIndex].getAttribute('data-price');
}

function updateAddonFrequency(sel) {
  sel.closest('.addon-card').setAttribute('data-frequency', sel.options[sel.selectedIndex].value)  
  sel.closest('.addon-card').setAttribute('data-selling-plan-name', sel.options[sel.selectedIndex].getAttribute('data-plan-name'))  

  console.log('this is the ', sel.options[sel.selectedIndex].getAttribute('data-plan-name'))
}